import { render, staticRenderFns } from "./bonusRules.popup-chunk.vue?vue&type=template&id=79627d99&scoped=true"
import script from "./bonusRules.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./bonusRules.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./bonusRules.popup-chunk.vue?vue&type=style&index=0&id=79627d99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79627d99",
  null
  
)

export default component.exports